import { render, staticRenderFns } from "./SessionExpire.vue?vue&type=template&id=ca7b198c&"
import script from "./SessionExpire.vue?vue&type=script&lang=js&"
export * from "./SessionExpire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports